import React from 'react'
import { Box, Container } from '@mui/material'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useSectionMetaData } from '@v4/components/common/SectionItem'
import { CATEGORY_VARIANTS } from '../Sections.const'

const Category = ({ variant = CATEGORY_VARIANTS.VARIANT_1, Element }) => {
	const metaData = useSectionMetaData()

	return (
		<Box className={clsx(variant, 'section-category')}>
			<Container className="section-category-content">{Element && <Element metaData={metaData} />}</Container>
		</Box>
	)
}

Category.propTypes = {
	variant: PropTypes.oneOf(Object.values(CATEGORY_VARIANTS)),
	Element: PropTypes.elementType,
}

export default Category
